import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { ChevronDown } from 'lucide-react';

const languages = [
  { code: 'el', label: 'GR', flag: '/flags/gr.svg' },
  { code: 'en', label: 'EN', flag: '/flags/gb.svg' },
];

const LanguageSwitcher = () => {
  const { lang, switchLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = languages.find((l) => l.code === lang) || languages[0];

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className="relative" ref={ref} data-testid="language-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-white/10 bg-white/5 hover:bg-white/10 transition-all text-sm text-white"
        data-testid="language-switcher-btn"
      >
        <img src={current.flag} alt={current.label} className="w-5 h-4 rounded-sm object-cover" />
        <span className="font-medium">{current.label}</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-2 glass-card rounded-lg border border-white/10 overflow-hidden min-w-[100px] z-50">
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                switchLanguage(l.code);
                setOpen(false);
              }}
              className={`w-full flex items-center gap-2 px-3 py-2.5 text-sm transition-colors ${
                lang === l.code
                  ? 'text-[#FF5E00] bg-[#FF5E00]/10'
                  : 'text-zinc-300 hover:text-white hover:bg-white/5'
              }`}
              data-testid={`lang-option-${l.code}`}
            >
              <img src={l.flag} alt={l.label} className="w-5 h-4 rounded-sm object-cover" />
              <span className="font-medium">{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
